import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../../store/theme.actions';
import { ControleEntrada } from './ControleEntrada';

function ControleEntradaPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Controle de Entrada'));
  return (
    <ControleEntrada />
  );
}

export default withTokenInterceptor(ControleEntradaPage);
